module.exports = __webpack_public_path__ + "img/579226e.jpg";